import { BFScreen } from "@/components/standard/screen/BFScreen"
import { SoftCreditPollScreen } from "@/screens/loans/SoftCreditPollScreen"
import { KeyboardAvoidingView, View } from "react-native"
import { H2 } from "@/components/standard/BFText"
import { useUser } from "@/queries/user"
import { router } from "expo-router"
import { showSuccessToast } from "@/components/toasts/AppToast"
import { useLoanContext } from "@/screens/loans/components/LoanContext"

export default function LoanSpecificSoftCreditPollScreen() {
  const { data: user } = useUser()
  const { loanId } = useLoanContext()

  return (
    <KeyboardAvoidingView
      testID={"soft-credit-poll-screen"}
      behavior="padding"
      className={"flex-1"}
    >
      <BFScreen
        headerSticky={false}
        dark={false}
        className={"p-5 flex-1"}
        header={
          <View className={"py-5"}>
            <H2>Soft Credit Pull</H2>
          </View>
        }
      >
        <SoftCreditPollScreen
          onSubmit={() => {
            showSuccessToast({
              title: "Soft Credit Pull Submitted",
              message: "Your soft credit pull has been submitted successfully.",
              autoHide: true,
              visibilityTime: 5000,
            })
            router.back()
          }}
          defaults={{
            loanId,
            firstName: user?.me?.firstName,
            lastName: user?.me?.lastName,
            phoneNumber: user?.me?.phoneNumber || undefined,
          }}
        />
      </BFScreen>
    </KeyboardAvoidingView>
  )
}
